<template>
	<div class="asd" >
		<el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
		  <el-form-item label="通知标题" width="100">
		    <el-input v-model="formLabelAlign.name" placeholder="请输入通知标题" style="width: 40%"></el-input>
		  </el-form-item>
         <el-form-item    label="通知人员" >
		    <el-select   v-model="formLabelAlign.region"  placeholder="请选通知的人员"  style="width: 40%">
		      <el-option label="一" value="我"></el-option>
		      <el-option label="二" value="你"></el-option>
		    </el-select>
		  </el-form-item>
		  <el-form-item label="通知内容">
		   <quill-editor ref="myTextEditor" class="editer"> </quill-editor>
		 </el-form-item>
		</el-form>
		<el-button  type="success" style="margin-left:78px;width: 150px;font-size:18px;">保 存</el-button>
	</div>
</template>

<script>
    	import { quillEditor } from 'vue-quill-editor' //调用编辑器
	 export default {
    name: 'Add',
    props: [''],
    data () {
      return {
           labelPosition: 'left',
            content:"请输入通知内容(建议150字以内)" ,
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        }
      };
    },
    methods: {
       
    },
      components: {
  	//使用编辑器
      quillEditor  
      
      }
  }
</script>

<style scoped="scoped">
	.asd{
		background-color: white;
		height: 100%;
		text-align: left;
		padding-top: 30px;
		padding-left: 30px;
	}
	.editer{
	height: 200px;
    width: 95%;
    margin-bottom: 100px
    }
</style>


// WEBPACK FOOTER //
// src/pages/park/AddInform.vue